const olElements = document.querySelectorAll('ol');
olElements.forEach((ol) => {
  const start = parseInt(ol.getAttribute('start'));
  ol.style.counterReset = `list-counter ${start || 1}`;
});